import axios from 'axios';

const instance = axios.create({
  // Aapka existing base URL bilkul safe rahega
  baseURL: 'https://crmm.sinfode.com', 
  withCredentials: true, 
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Automatic header mapping for cookies injection
instance.defaults.xsrfCookieName = 'XSRF-TOKEN';
instance.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

export default instance;
